module.exports = __webpack_public_path__ + "img/title_img.adcbe0b0.png";